import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AddVehicleFormComponent } from '../../../dialogs/add-vehicle-form/add-vehicle-form.component';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { SavedVehicle } from '../../../../graphql/generated/generated-types';
import { ActiveService } from '../../../../core/providers/active/active.service';

@Component({
  selector: 'app-add-vehicle-button-block',
  standalone: true,
  imports: [AddVehicleFormComponent, ButtonModule, RippleModule],
  templateUrl: './add-vehicle-button-block.component.html',
  styleUrl: './add-vehicle-button-block.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddVehicleButtonBlockComponent implements OnChanges {
  @Input() selectedVehicle: SavedVehicle;
  @Input() disabled: boolean = false;
  @Output() selectedVehicleEvent: EventEmitter<any> = new EventEmitter<any>();
  constructor(private dialogService: DialogService, private cdr: ChangeDetectorRef, private activeService: ActiveService) {}

  public showAddVehicleDialog() {
    const dialogRef: DynamicDialogRef = this.dialogService.open(
      AddVehicleFormComponent,
      {
        data: {
          id: 'test',
          selectedVehicle: this.selectedVehicle,
        },
        modal: true,
        dismissableMask: true,
        focusOnShow: false,
        styleClass: 'add-vehicle-dialog large-dialog',
        header: this.selectedVehicle ? 'Manage vehicles' : 'Add vehicle',
      }
    );

    dialogRef.onClose.subscribe((result) => {
      if (result) {
        this.selectedVehicleEvent.emit(true);
      } else {
        this.selectedVehicleEvent.emit(false);
      }
      this.activeService.suggestedVehicleDialogIsOpened = false;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if('selectedVehicle' in changes){
      this.selectedVehicle = changes['selectedVehicle'].currentValue;
    }
    this.cdr.markForCheck();
  }
}
